<template>
  <div :key="configuracao.idlocalconfig">
    <fcc-modal-texto-padrao :payload-base="payloadBase" />

    <fcc-stepper :step="step" />

    <fcc-data-periodo
      v-show="step === 1"
      :lista="listaDataPeriodoHora"
      @proximo="step = step + 1"
      @seleciona-itens="selecionaDatas"
    />
    <fcc-todos-grupos
      v-show="step === 2"
      :lista="grupos"
      @proximo="step = step + 1"
      @anterior="step = step - 1"
      @seleciona-itens="selecionaGrupos"
    />
    <fcc-todas-cidades-prova
      v-show="step === 3"
      :lista="cidades"
      @proximo="step = step + 1"
      @anterior="step = step - 1"
      @seleciona-itens="selecionaCidades"
    />
    <fcc-todos-colegios
      v-show="step === 4"
      :lista="colegios"
      @anterior="step = step - 1"
      @seleciona-itens="selecionaColegios"
    />

    <div class="text-right mb-3">
      <fcc-button class="mr-2" color="secondary" disabled>Buscar por N° Pedido</fcc-button>
      <fcc-button
        class="mr-2"
        @click="showModalAlterarTextoPadrao"
        :disabled="textoPadraoDesabilitado"
        >Texto-padrão</fcc-button
      >
    </div>
  </div>
</template>

<script>
import FccTodasCidadesProva from './fccTodasCidadesProva.vue'
import FccTodosGrupos from './fccTodosGrupos.vue'
import FccTodosColegios from './fccTodosColegios.vue'
import FccModalTextoPadrao from './fccModalTextoPadrao.vue'
import FccDataPeriodo from './fccDataPeriodo.vue'
import fccStepper from './fccStepper.vue'
import axios from 'axios'
import fccStore from '@/store'

export default {
  components: {
    FccTodosGrupos,
    FccTodasCidadesProva,
    FccTodosColegios,
    FccModalTextoPadrao,
    FccDataPeriodo,
    fccStepper
  },
  data() {
    return {
      listaDataPeriodoHora: [],
      grupos: [],
      cidades: [],
      colegios: [],
      idDatas: '',
      idGrupos: '',
      idCidades: '',
      idColegios: '',
      step: 1
    }
  },
  mounted() {
    this.listaDataPeridoHora()
  },
  computed: {
    configuracao() {
      return fccStore.state.localDeProva.configuracao
    },
    textoPadraoDesabilitado() {
      switch (this.step) {
        case 1:
          return this.idDatas === ''
        case 2:
          return this.idGrupos === ''
        case 3:
          return this.idCidades === ''
        case 4:
          return this.idColegios === ''
        default:
          return true
      }
    },
    payloadBase() {
      const obj = {
        idLocalConfig: this.configuracao.idlocalconfig,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario,
        idDatas: '',
        idGrupos: '',
        idCidades: '',
        idColegios: ''
      }

      switch (this.step) {
        case 1:
          obj.idDatas = this.idDatas
          break
        case 2:
          obj.idGrupos = this.idGrupos
          break
        case 3:
          obj.idCidades = this.idCidades
          break
        case 4:
          obj.idColegios = this.idColegios
          break
      }

      return obj
    }
  },
  methods: {
    showModalAlterarTextoPadrao() {
      this.$root.$emit('bv::show::modal', 'modal-texto-padrao')
    },
    selecionaDatas(idDatas) {
      this.idDatas = idDatas
      this.listaGrupo()
    },
    selecionaGrupos(idGrupos) {
      this.idGrupos = idGrupos
      this.listaGrupoCidade()
    },
    selecionaCidades(idCidades) {
      this.idCidades = idCidades
      this.listaGrupoCidadeColegio()
    },
    selecionaColegios(idColegios) {
      this.idColegios = idColegios
    },
    listaDataPeridoHora() {
      return new Promise((resolve) => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .get(
            fccStore.state.baseUrlLocalDeProva +
              `Colegio/ListaDataPeridoHora/${this.configuracao.idlocalconfig}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.listaDataPeriodoHora = response.data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    listaGrupo() {
      return new Promise((resolve) => {
        const payload = {
          idLocalConfig: this.configuracao.idlocalconfig,
          idDatas: this.idDatas
        }

        axios
          .post(
            fccStore.state.baseUrlLocalDeProva + `LocalExameApresentacao/ListaGrupo`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.grupos = response.data

            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    listaGrupoCidade() {
      return new Promise((resolve) => {
        const payload = {
          idLocalConfig: this.configuracao.idlocalconfig,
          idDatas: this.idDatas,
          idGrupos: this.idGrupos
        }

        axios
          .post(
            fccStore.state.baseUrlLocalDeProva + `Colegio/ListaGrupoCidade`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.cidades = response.data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    listaGrupoCidadeColegio() {
      return new Promise((resolve) => {
        const payload = {
          idLocalConfig: this.configuracao.idlocalconfig,
          idDatas: this.idDatas,
          idGrupos: this.idGrupos,
          idCidades: this.idCidades
        }

        axios
          .post(
            fccStore.state.baseUrlLocalDeProva + `Colegio/ListaGrupoCidadeColegio`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.colegios = response.data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    }
  }
}
</script>